<template>
	<div v-if="show && jobProfile" :class="slideInClass">
		<header class="titled">
			<div>
				<h4>{{ title || inquiryToEdit.label }}</h4>
				<h3 v-if="subTitle" v-html="subTitle"/>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan({ confirmed: false })">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check flex-grow-1">
			<Function
				v-if="inquiryToEdit && inquiryToEdit.id === 'function'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionDetail
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-detail'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionAssistance
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-assistance'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionLegalField
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-legal-field'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionLegalRole
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-legal-role'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionTaxField
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-tax-field'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionTaxRole
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-tax-role'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionMarketingRole
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-marketing-role'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<CareerLevel
				v-if="inquiryToEdit && inquiryToEdit.id === 'career-level'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<IndustrialSector
				v-if="inquiryToEdit && inquiryToEdit.id === 'industrial-sector'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<OrganisationalArea
				v-if="inquiryToEdit && inquiryToEdit.id === 'organisational-area'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<EmploymentMode
				v-if="inquiryToEdit && inquiryToEdit.id === 'employment-mode'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<HiringDate
				v-if="inquiryToEdit && inquiryToEdit.id === 'hiring-date'"
				v-model="inquiryData"
			/>
			<WorkingHours
				v-if="inquiryToEdit && inquiryToEdit.id === 'working-hours'"
				v-model="inquiryData"
			/>
			<EmploymentDuration
				v-if="inquiryToEdit && inquiryToEdit.id === 'employment-duration'"
				v-model="inquiryData"
			/>
			<PlaceOfWork
				v-if="inquiryToEdit && inquiryToEdit.id === 'place-of-work'"
				v-model="inquiryData"
			/>
			<HomeOffice
				v-if="inquiryToEdit && inquiryToEdit.id === 'home-office'"
				v-model="inquiryData"
			/>
			<Salary
				v-if="inquiryToEdit && inquiryToEdit.id === 'salary'"
				v-model="inquiryData"
			/>
			<HourlyRate
				v-if="inquiryToEdit && inquiryToEdit.id === 'hourly-rate'"
				v-model="inquiryData"
			/>
			<CompanyType
				v-if="inquiryToEdit && inquiryToEdit.id === 'company-type'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<CompanySize
				v-if="inquiryToEdit && inquiryToEdit.id === 'company-size'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Management
				v-if="inquiryToEdit && inquiryToEdit.id === 'management'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<CustomerContact
				v-if="inquiryToEdit && inquiryToEdit.id === 'customer-contact'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<WorkingTime
				v-if="inquiryToEdit && inquiryToEdit.id === 'working-time'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Overtime
				v-if="inquiryToEdit && inquiryToEdit.id === 'overtime'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Parking
				v-if="inquiryToEdit && inquiryToEdit.id === 'parking'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<PrivateVehicleCompanyUsage
				v-if="inquiryToEdit && inquiryToEdit.id === 'private-vehicle-company-usage'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<CompanyCar
				v-if="inquiryToEdit && inquiryToEdit.id === 'company-car'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<DrivingLicense
				v-if="inquiryToEdit && inquiryToEdit.id === 'driving-license'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<PilotLicense
				v-if="inquiryToEdit && inquiryToEdit.id === 'pilot-license'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<PublicTransport
				v-if="inquiryToEdit && inquiryToEdit.id === 'public-transport'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionLegalFieldExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-legal-field-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionLegalRoleExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-legal-role-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionTaxFieldExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-tax-field-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionTaxRoleExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-tax-role-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<FunctionMarketingRoleExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'function-marketing-role-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<CareerLevelExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'career-level-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<IndustrialSectorExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'industrial-sector-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<OrganisationalAreaExperience
				v-if="inquiryToEdit && inquiryToEdit.id === 'organisational-area-experience'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Language
				v-if="inquiryToEdit && inquiryToEdit.id === 'language'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<SoftwareMain
				v-if="inquiryToEdit && inquiryToEdit.id === 'software-main'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<SoftwareSpecial
				v-if="inquiryToEdit && inquiryToEdit.id === 'software-special'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Skills
				v-if="inquiryToEdit && inquiryToEdit.id === 'skills'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Benefits
				v-if="inquiryToEdit && inquiryToEdit.id === 'benefits'"
				v-model="inquiryData"
				:meta="meta"
				:job-profile="jobProfile"
			/>
			<SearchStatus
				v-if="inquiryToEdit && inquiryToEdit.id === 'search-status'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<TravelWillingness
				v-if="inquiryToEdit && inquiryToEdit.id === 'travel-willingness'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Citizenship
				v-if="inquiryToEdit && inquiryToEdit.id === 'citizenship'"
				v-model="inquiryData"
				:meta="meta"
			/>
			<Education
				v-if="inquiryToEdit && inquiryToEdit.id === 'education'"
				v-model="inquiryData"
				:meta="meta"
				:with-title="false"
			/>
			<IncognitoMode
				v-if="inquiryToEdit && inquiryToEdit.id === 'incognito-mode'"
				v-model="inquiryData"
			/>
		</main>
		<footer>
			<Button
				text="Speichern"
				:disabled="!inquiryDataValid || saving"
				:loading="saving"
				icon="checkmark"
				@click="save"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon";
import Button from "@/vue/common/Button";
import _ from "lodash";
import * as Inquiry from "@/helper/job-profile/Inquiry"
import * as PreSavePreparation from "@/helper/job-profile/PreSavePreparation";
import Function from "@/vue/customer-area/job-profile/edit/Function";
import FunctionDetail from "@/vue/customer-area/job-profile/edit/FunctionDetail";
import FunctionAssistance from "@/vue/customer-area/job-profile/edit/FunctionAssistance";
import CareerLevel from "@/vue/customer-area/job-profile/edit/CareerLevel";
import * as Log from "@/helper/Log";
import * as Toast from "@/helper/layout/Toast";
import JobProfileSave from "@/api/customer/job-profile/Save"
import flatten from "@/helper/error/Errors";
import IndustrialSector from "@/vue/customer-area/job-profile/edit/IndustrialSector";
import HiringDate from "@/vue/customer-area/job-profile/edit/HiringDate";
import PlaceOfWork from "@/vue/customer-area/job-profile/edit/PlaceOfWork";
import HomeOffice from "@/vue/customer-area/job-profile/edit/HomeOffice";
import CompanyType from "@/vue/customer-area/job-profile/edit/CompanyType";
import CompanySize from "@/vue/customer-area/job-profile/edit/CompanySize";
import CustomerContact from "@/vue/customer-area/job-profile/edit/CustomerContact";
import WorkingTime from "@/vue/customer-area/job-profile/edit/WorkingTime";
import Parking from "@/vue/customer-area/job-profile/edit/Parking";
import PrivateVehicleCompanyUsage from "@/vue/customer-area/job-profile/edit/PrivateVehicleCompanyUsage";
import CompanyCar from "@/vue/customer-area/job-profile/edit/CompanyCar";
import DrivingLicense from "@/vue/customer-area/job-profile/edit/DrivingLicense";
import PilotLicense from "@/vue/customer-area/job-profile/edit/PilotLicense";
import PublicTransport from "@/vue/customer-area/job-profile/edit/PublicTransport";
import FunctionExperience from "@/vue/customer-area/job-profile/edit/FunctionExperience";
import FunctionLegalFieldExperience from "@/vue/customer-area/job-profile/edit/FunctionLegalFieldExperience";
import FunctionLegalRoleExperience from "@/vue/customer-area/job-profile/edit/FunctionLegalRoleExperience";
import FunctionTaxFieldExperience from "@/vue/customer-area/job-profile/edit/FunctionTaxFieldExperience";
import FunctionTaxRoleExperience from "@/vue/customer-area/job-profile/edit/FunctionTaxRoleExperience";
import FunctionMarketingRoleExperience from "@/vue/customer-area/job-profile/edit/FunctionMarketingRoleExperience";
import CareerLevelExperience from "@/vue/customer-area/job-profile/edit/CareerLevelExperience";
import IndustrialSectorExperience from "@/vue/customer-area/job-profile/edit/IndustrialSectorExperience";
import Language from "@/vue/customer-area/job-profile/edit/Language";
import SoftwareMain from "@/vue/customer-area/job-profile/edit/SoftwareMain";
import SoftwareSpecial from "@/vue/customer-area/job-profile/edit/SoftwareSpecial";
import Skills from "@/vue/customer-area/job-profile/edit/Skills";
import Benefits from "@/vue/customer-area/job-profile/edit/Benefits";
import SearchStatus from "@/vue/customer-area/job-profile/edit/SearchStatus";
import Salary from "@/vue/customer-area/job-profile/edit/Salary";
import HourlyRate from "@/vue/customer-area/job-profile/edit/HourlyRate";
import Overtime from "@/vue/customer-area/job-profile/edit/Overtime";
import WorkingHours from "@/vue/customer-area/job-profile/edit/WorkingHours";
import EmploymentDuration from "@/vue/customer-area/job-profile/edit/EmploymentDuration";
import Management from "@/vue/customer-area/job-profile/edit/Management";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job-profile/edit";
import EmploymentMode from "@/vue/customer-area/job-profile/edit/EmploymentMode";
import TravelWillingness from "@/vue/customer-area/job-profile/edit/TravelWillingness";
import Citizenship from "@/vue/customer-area/job-profile/edit/Citizenship";
import FunctionLegalField from "@/vue/customer-area/job-profile/edit/FunctionLegalField";
import FunctionLegalRole from "@/vue/customer-area/job-profile/edit/FunctionLegalRole";
import FunctionTaxField from "@/vue/customer-area/job-profile/edit/FunctionTaxField";
import FunctionTaxRole from "@/vue/customer-area/job-profile/edit/FunctionTaxRole";
import FunctionMarketingRole from "@/vue/customer-area/job-profile/edit/FunctionMarketingRole";
import Education from "@/vue/customer-area/job-profile/edit/Education.vue";
import IncognitoMode from "@/vue/customer-area/job-profile/edit/IncognitoMode.vue";
import OrganisationalAreaExperience from "@/vue/customer-area/job-profile/edit/OrganisationalAreaExperience.vue";
import OrganisationalArea from "@/vue/customer-area/job-profile/edit/OrganisationalArea.vue";

const INQUIRIES = {
	[Inquiry.FUNCTION]: {
		property: 'functions',
	},
	[Inquiry.FUNCTION_DETAIL]: {
		property: 'functionDetail',
	},
	[Inquiry.FUNCTION_ASSISTANCE]: {
		property: 'functionAssistance',
	},
	[Inquiry.FUNCTION_LEGAL_FIELD]: {
		property: 'functionLegalField',
	},
	[Inquiry.FUNCTION_LEGAL_ROLE]: {
		property: 'functionLegalRole',
	},
	[Inquiry.FUNCTION_TAX_FIELD]: {
		property: 'functionTaxField',
	},
	[Inquiry.FUNCTION_TAX_ROLE]: {
		property: 'functionTaxRole',
	},
	[Inquiry.FUNCTION_MARKETING_ROLE]: {
		property: 'functionMarketingRole',
	},
	[Inquiry.CAREER_LEVEL]: {
		property: 'careerLevels',
	},
	[Inquiry.INDUSTRIAL_SECTOR]: {
		property: 'industrialSectors',
	},
	[Inquiry.ORGANISATIONAL_AREA]: {
		property: 'organisationalArea',
	},
	[Inquiry.HIRING_DATE]: {
		property: 'hiringDate',
	},
	[Inquiry.PLACE_OF_WORK]: {
		property: 'placeOfWork',
	},
	[Inquiry.HOME_OFFICE]: {
		property: 'homeOffice',
	},
	[Inquiry.SALARY]: {
		property: 'salary',
	},
	[Inquiry.HOURLY_RATE]: {
		property: 'hourlyRate',
	},
	[Inquiry.WORKING_HOURS]: {
		property: 'workingHours',
	},
	[Inquiry.EMPLOYMENT_DURATION]: {
		property: 'employmentDuration',
	},
	// TODO DEACTIVATE?
	[Inquiry.EMPLOYMENT_MODE]: {
		property: 'employmentMode',
	},
	[Inquiry.TRAVEL_WILLINGNESS]: {
		property: 'travelWillingness',
	},
	[Inquiry.COMPANY_TYPE]: {
		property: 'companyType',
	},
	[Inquiry.COMPANY_SIZE]: {
		property: 'companySize',
	},
	[Inquiry.MANAGEMENT]: {
		property: 'management',
	},
	[Inquiry.CUSTOMER_CONTACT]: {
		property: 'customerContact',
	},
	[Inquiry.WORKING_TIME]: {
		property: 'workingTime',
	},
	[Inquiry.OVERTIME]: {
		property: 'overtime',
	},
	[Inquiry.PARKING]: {
		property: 'parking',
	},
	[Inquiry.PUBLIC_TRANSPORT]: {
		property: 'publicTransport',
	},
	[Inquiry.PRIVATE_VEHICLE_COMPANY_USAGE]: {
		property: 'privateVehicleCompanyUsage',
	},
	[Inquiry.COMPANY_CAR]: {
		property: 'companyCar',
	},
	[Inquiry.DRIVING_LICENSE]: {
		property: 'drivingLicense',
	},
	[Inquiry.PILOT_LICENSE]: {
		property: 'pilotLicense',
	},
	[Inquiry.FUNCTION_EXPERIENCE]: {
		property: 'functionsExperience',
	},
	[Inquiry.FUNCTION_LEGAL_FIELD_EXPERIENCE]: {
		property: 'functionLegalFieldExperience',
	},
	[Inquiry.FUNCTION_LEGAL_ROLE_EXPERIENCE]: {
		property: 'functionLegalRoleExperience',
	},
	[Inquiry.FUNCTION_TAX_FIELD_EXPERIENCE]: {
		property: 'functionTaxFieldExperience',
	},
	[Inquiry.FUNCTION_TAX_ROLE_EXPERIENCE]: {
		property: 'functionTaxRoleExperience',
	},
	[Inquiry.FUNCTION_MARKETING_ROLE_EXPERIENCE]: {
		property: 'functionMarketingRoleExperience',
	},
	[Inquiry.CAREER_LEVEL_EXPERIENCE]: {
		property: 'careerLevelsExperience',
	},
	[Inquiry.INDUSTRIAL_SECTOR_EXPERIENCE]: {
		property: 'industrialSectorsExperience',
	},
	[Inquiry.ORGANISATIONAL_AREA_EXPERIENCE]: {
		property: 'organisationalAreaExperience',
	},
	[Inquiry.LANGUAGE]: {
		property: 'languages',
	},
	[Inquiry.SOFTWARE_MAIN]: {
		property: 'softwareMain',
	},
	[Inquiry.SOFTWARE_SPECIAL]: {
		property: 'softwareSpecial',
	},
	[Inquiry.SKILLS]: {
		property: 'skills',
	},
	[Inquiry.BENEFITS]: {
		property: 'benefits',
	},
	[Inquiry.SEARCH_STATUS]: {
		property: 'searchStatus',
	},
	[Inquiry.CITIZENSHIP]: {
		property: 'citizenship',
	},
	[Inquiry.EDUCATION]: {
		property: 'education',
	},
	[Inquiry.INCOGNITO_MODE]: {
		property: 'incognitoMode',
	},
};

export default {

	components: {
		OrganisationalArea,
		OrganisationalAreaExperience,
		IncognitoMode,
		FunctionDetail,
		Education,
		FunctionTaxRole,
		FunctionTaxField,
		FunctionLegalRole,
		FunctionLegalField,
		FunctionAssistance,
		FunctionMarketingRole,
		Citizenship,
		TravelWillingness,
		EmploymentMode,
		EmploymentDuration,
		HomeOffice,
		PlaceOfWork,
		WorkingHours,
		HiringDate,
		IndustrialSector,
		Icon,
		Button,
		Function,
		CareerLevel,
		CompanyType,
		CompanySize,
		CustomerContact,
		WorkingTime,
		Parking,
		PrivateVehicleCompanyUsage,
		CompanyCar,
		DrivingLicense,
		PilotLicense,
		PublicTransport,
		FunctionExperience,
		FunctionLegalFieldExperience,
		FunctionLegalRoleExperience,
		FunctionTaxFieldExperience,
		FunctionTaxRoleExperience,
		FunctionMarketingRoleExperience,
		CareerLevelExperience,
		IndustrialSectorExperience,
		Language,
		SoftwareMain,
		SoftwareSpecial,
		Skills,
		Benefits,
		SearchStatus,
		Salary,
		HourlyRate,
		Overtime,
		Management,
	},

	data ()
	{
		return {
			inquiryData: undefined,
			saving: false,
			modifiedData: {},
			jobProfileName: ''
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('layout', ['fanLevelClasses']),
		...mapState('jobProfile/edit', [
			'show',
			'inquiryToEdit',
			'initialData',
			'title',
			'subTitle',
			'jobProfile',
			'onSave',
		]),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		inquiryDataValid ()
		{
			return this.inquiryData !== undefined;
		},
	},

	methods: {
		...mapActions('jobProfile/edit', {
			closeFan: 'close'
		}),
		getInquiryConfig (inquiry)
		{
			return INQUIRIES[inquiry.id];
		},
		async save ()
		{
			this.saving = true;

			this.modifiedData[this.inquiryToEdit.id] = this.inquiryData;

			let itemData = _.cloneDeep(this.inquiryData);

			const inquiryConfig = this.getInquiryConfig(this.inquiryToEdit);

			try
			{
				const preparedData = PreSavePreparation.prepare({
					[inquiryConfig.property]: itemData
				});

				await new JobProfileSave()
					.setJobProfileId(this.jobProfile.jobProfile.id)
					.setData(preparedData)
					.call();

				if (this.onSave)
				{
					this.onSave({
						jobProfile: this.jobProfile
					});
				}

				Toast.success(this, ['Erfolgreich gespeichert']);

				await this.closeFan({ confirmed: true });
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
	},

	watch: {
		jobProfile (jobProfile)
		{
			if (jobProfile)
			{
				this.jobProfileName = jobProfile.jobProfile.name;
				this.inquiryData = this.initialData;
			}
		}
	}
}
</script>
